import request from '@/utils/request';

export const shopApi = {
  // 创建订单
  createOrder(data) {
    return request.post('/shop/orders', data);
  },

  // 获取用户订单列表（支持搜索）
  getUserOrders(status = 'all', searchQuery = '') {
    return request.get('/shop/orders', { 
      params: { 
        status,
        search: searchQuery 
      } 
    });
  },

  // 获取订单详情
  getOrderById(orderId) {
    return request.get(`/shop/orders/${orderId}`);
  },

  // 支付订单
  payOrder(orderId, paymentMethod) {
    return request.post(`/shop/orders/${orderId}/pay`, { paymentMethod });
  },

  // 取消订单
  cancelOrder(orderId, reason = '用户主动取消') {
    return request.post(`/shop/orders/${orderId}/cancel`, { reason });
  },

  // 确认收货
  confirmDelivery(orderId) {
    return request.post(`/shop/orders/${orderId}/confirm`);
  },

  // 提交订单评价
  submitReview(orderId, data) {
    return request.post(`/shop/orders/${orderId}/review`, data);
  },

  // 提交退款申请
  submitRefund(orderId, data) {
    return request.post(`/shop/orders/${orderId}/refund`, data);
  },

  // 生成支付二维码
  generatePaymentQRCode(orderId, paymentMethod) {
    return request.post(`/shop/orders/${orderId}/qrcode`, { paymentMethod });
  },

  // 重新激活已取消的订单（再次购买）
  reactivateOrder(orderId, paymentMethod) {
    return request.post(`/shop/orders/${orderId}/reactivate`, { paymentMethod });
  },

  // ========== 运维管理员接口 ==========
  
  // 获取所有订单（运维管理员）
  getAllOrders(status = 'all', searchQuery = '') {
    return request.get('/shop/admin/orders', {
      params: {
        status,
        search: searchQuery
      }
    });
  },

  // 更新订单状态（运维管理员）
  updateOrderStatus(orderId, status) {
    return request.put(`/shop/admin/orders/${orderId}/status`, { status });
  },

  // 更新订单物流信息（运维管理员）
  updateOrderLogistics(orderId, logisticsData) {
    return request.put(`/shop/admin/orders/${orderId}/logistics`, logisticsData);
  },

  // 添加物流轨迹记录（运维管理员）
  addLogisticsTracking(orderId, trackingData) {
    return request.post(`/shop/admin/orders/${orderId}/tracking`, trackingData);
  },

  // 获取订单物流轨迹列表（运维管理员）
  getLogisticsTrackingList(orderId) {
    return request.get(`/shop/admin/orders/${orderId}/tracking`);
  },

  // 驳回退款申请（运维管理员）
  rejectRefund(orderId, adminRemark = '') {
    return request.post(`/shop/admin/orders/${orderId}/refund/reject`, { adminRemark });
  },

  // 同意退款申请（运维管理员）
  approveRefund(orderId) {
    return request.post(`/shop/admin/orders/${orderId}/refund/approve`);
  }
};
